import Component from '@glimmer/component';
import { PrismBadge } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import { eq } from 'ember-truth-helpers';

import styles from './td-room.module.css';

interface HotelPricingAssistantTableCellsTdRoomSignature {
  Args: {
    cellData: {
      isBaseRoom: boolean;
      roomName: string;
    };
    column?: {
      variant?: 'column';
    };
    row: {
      isRoomCategory: boolean;
      roomCategory: string;
    };
  };
}

export default class HotelPricingAssistantTableCellsTdRoom extends Component<HotelPricingAssistantTableCellsTdRoomSignature> {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get roomName() {
    return this.args.row.isRoomCategory
      ? this.args.row.roomCategory
      : this.args.cellData.roomName;
  }

  <template>
    <div
      class="{{styles.container}}
        {{if (eq @column.variant 'column') styles.container--column}}
        {{if @cellData.isBaseRoom 'py-200'}}"
    >
      <p
        class="{{styles.title}}
          {{if (eq @column.variant 'column') styles.title--bold}}"
        title={{this.roomName}}
      >
        {{this.roomName}}
      </p>
      {{#if @cellData.isBaseRoom}}
        <div class="text-nowrap">
          <PrismBadge
            @badgeType="neutral"
            @label={{t
              "pricing_assistant.settings.panel.section.rooms.leading_room"
            }}
          />
        </div>
      {{/if}}
    </div>
  </template>
}
